// store/modules/dialog.js
const state = {
  visible: false, // 弹窗显示状态
  courses: [], // 课程列表数据
  currentPage: 1, // 弹窗当前页码
  pageSize: 5, // 每页条数
  total: 0, // 总条数
};

const mutations = {
  SET_DIALOG_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_DIALOG_VISIBLE(state, visible) {
    state.visible = visible;
  },
  SET_DIALOG_COURSES(state, courses) {
    state.courses = courses;
    state.total = courses.length; // 自动计算总条数
  },
  SET_DIALOG_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_DIALOG_PAGE_SIZE(state, size) {
    state.pageSize = size;
  },
  RESET_DIALOG(state) {
    state.visible = false;
    state.courses = [];
    state.currentPage = 1;
    state.total = 0;
  },
};

const actions = {
  showDialog({ commit }, courses) {
    commit("SET_DIALOG_COURSES", courses);
    commit("SET_DIALOG_VISIBLE", true);
  },
  closeDialog({ commit }) {
    commit("RESET_DIALOG");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
